(function($) {
    $(".part_ui_select").find("select").on("click",function() {
        $(this).parent().toggleClass("mod--focus");
        $(this).one("blur",function() {
            $(this).parent().removeClass("mod--focus");
        });
    });
})(jQuery);